import React, {useState, useEffect} from 'react';
import './ClubCalendrier.css';

import { apiLink, URL_WS_URL } from '../variables';

import axios from 'axios';
import Match from './Match';

function ClubCalendrier({championnat, club}) {
    const [matchs, setMatchs] = useState([]);
    const [livescoringMatchs, setLivescoringMatchs] = useState([]);

    useEffect(() => {
        // on récupère les matchs
        getMatchs();
        getLivescoringMatchs();
    }, [championnat]);

    const getMatchs = async () => {
        const link = apiLink.find(item => item.for == championnat).link;
        if (link !== '') {
            axios
            .get(link, {
                "Content-Type": "application/xml; charset=utf-8"
            })
            .then(function(res) {
                setMatchs(res.data);
            })
            .catch(function(error) {
                console.log(error);
            });
        } 
    }

    const getLivescoringMatchs = async () => {
        const link = URL_WS_URL + "/livescore/all_livescores";
        axios
        .get(link, {
            "Content-Type": "application/xml; charset=utf-8"
        })
        .then(function(res) {
            var data = res.data;
            setLivescoringMatchs(data)
        })
        .catch(function(error) {
            console.log(error);
        });
    }


    const getHeaderLivescore = (renc_id) => {
        let headerLivescore = {};
        if (livescoringMatchs !== null && livescoringMatchs !== undefined) {
            if (livescoringMatchs.list !== undefined) {
                for (const div of livescoringMatchs.list) {
                    // S'il y a des matchs dans la div alors on regarde s'il y a le match qu'on veut
                    const match = div.matchs.find(item => item.renc_id === renc_id);
                    if (match !== undefined) {
                        headerLivescore = match;
                        break; // Sort complètement de la boucle externe
                    }
                }
            }
        }
        return headerLivescore;
    }

    const info = (index, value) => {
        return matchs[index][value];
    }

    const getRencID = (index) => {
        const cData = matchs[index].lien;
        const rencID = cData.split('renc_id=')[1].split('&')[0];
        return rencID;
    }

    const getEquipe1Num = (index) => {
        const cData = matchs[index].lien;
        const num = cData.split('clubnum_1=')[1].split('&')[0];
        return num;
    }

    const getEquipe2Num = (index) => {
        const cData = matchs[index].lien;
        const num = cData.split('clubnum_2=')[1].split(' ')[0];
        return num;
    }

    const getDayMatch = (index) => {
        let tour = matchs[index].libelle.toString();
        tour = tour.split('°')[1].split(' ')[0];
        return parseInt(tour);
    }

    return ( 
        <div className="club_calendrier_component" style={{display: 'flex', justifyContent: 'center', paddingTop: 75, paddingBottom: 75}}>
            <div className="club_calendrier_content" style={{display: 'flex', flexDirection: 'column', gap: 25}}>
                {
                    matchs.map((item, index) => {
                        return (
                            ((getEquipe1Num(index) == club.identifier || info(index, 'equa') == club.title.toUpperCase()) || (getEquipe2Num(index) == club.identifier || info(index, 'equb') == club.title.toUpperCase()))
                            &&
                            <Match 
                                key={getRencID(index)} 
                                championnat={championnat} 
                                match={item} 
                                currentClub={club} 
                                headerLivescore={getHeaderLivescore(getRencID(index))}
                                currentDay={getDayMatch(index)}
                            />
                        )
                    })
                }
            </div>
        </div>
     );
}

export default ClubCalendrier;